import React, { FC, AnimationEventHandler } from 'react';
import cn from 'classnames';
require("./Textarea-Hint.css");
var styles = {
  "Root": "Textarea-Hint-module-Root_1in",
  "Hint_show": "Textarea-Hint-module-Hint_show_2se",
  "leave": "Textarea-Hint-module-leave_L1e",
  "Hint_leave": "Textarea-Hint-module-Hint_leave_1dv"
};
export const TextareaHint = ({
  leave,
  onAnimationEnd,
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: cn(styles.Root, {
    [styles.leave]: leave
  }, className),
  onAnimationEnd: onAnimationEnd
}, children);